import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";
import { getDocumentURL } from "../handler/ParentDataHandler";
import Text from "@amzn/meridian/text";
import Column from "@amzn/meridian/column";
import Link from "@amzn/meridian/link";
import { AR_V2 } from "./util/Constants";
import { CapabilityContext } from "../overview/context/CapabilityContext";

const ActionableMetricViewV2 = (props) => {
  const { capability } = useContext(CapabilityContext);
  const pageName = capability.data === AR_V2 ? "outbound" : "outboundAMZL";

  const onMetricCountClick = () => {
    getDocumentURL().then((result) => {
      const url = new URL(result.replace(pageName, props.data.targetTab));
      if (props.data.uri && props.data.targetTab !== "stow") {
        const shareableLink = `/${props.data.targetTab}/${props.data.uri}`;
        url.searchParams.set("shareableLink", shareableLink);
      } else if (props.data.uri && props.data.targetTab === "stow") {
        const shareableLink = `heatMap/${props.data.uri}`;
        url.searchParams.set("shareableLink", shareableLink);
      }
      window.open(url.href, "_parent");
    });
  };

  return (
    <Column spacing={"small"}>
      <Text type="d50">
        <Link type={"secondary"} onClick={onMetricCountClick}>
          {props.data.value}
        </Link>
      </Text>
      <Text type="b300" color={"secondary"}>
        <FormattedMessage
          id={props.data.title}
          defaultMessage={props.data.message}
        />
      </Text>
    </Column>
  );
};

export default ActionableMetricViewV2;



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/ActionableMetricViewV2.js